import React from "react";
import { Link } from "react-router-dom";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";
import Box from "@material-ui/core/Box";
import {
  displayAlertifyError,
  displayAlertifySuccess,
} from "../../util/functions";
// import Image from '../../../public/assets/img/bg2.jpg';

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      nameValdate: true,
      password: "",
      passValdate: true,
      host: APIModel.HOST,
    };
  }

  componentWillMount() {
    this.setState({ user_id: localStorage.getItem("user_id") });
    this.signInAsync();
  }

  componentDidMount() {
    alertify.set("notifier", "position", "top-right");
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.Login();
    }
  };
 
  Login = () => {
    alertify.set("notifier", "delay", 3);
    alertify.set("notifier", "position", "top-right");
    if (this.state.email == "" || this.state.email === undefined) {
      displayAlertifyError({ error: "Email is Required" });

      return;
    } else if (this.state.email.length > 0) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(this.state.email)) {
      } else {
        displayAlertifyError({ error: "Must be a valid Email Address" });

        return;
      }
    }

    if (this.state.password === "" || this.state.password === undefined) {
      displayAlertifyError({ error: "Please Enter Password" });
      return false;
    }

    fetch(this.state.host + "login", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        email: this.state.email,
        password: this.state.password,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        try {
          if (responseJson.user !== undefined) {
            // localStorage.setItem("UserType", "Admin");
            localStorage.setItem("user_id", responseJson.user.id);
            localStorage.setItem("Token", responseJson.access_token);
            localStorage.setItem("user_email", responseJson.user.email);
            localStorage.setItem("name", responseJson.user.name);
            localStorage.setItem("status", responseJson.user.status);
            if (responseJson.user.stripestatus != '') {
              localStorage.setItem(
                "stripestatus",
                responseJson.user.stripestatus
              );
            }
            if (responseJson.user.subscription_detail != null) {
              localStorage.setItem(
                "subscription",
                responseJson.user.subscription_detail.sub_type
              );
              localStorage.setItem(
                "created_at",
                responseJson.user.subscription_detail.created_at
              );
              localStorage.setItem(
                "renewdate",
                responseJson.user.subscription_detail.renewdate
              );
              localStorage.setItem(
                "sub_id",
                responseJson.user.subscription_detail.sub_id
              );
            }
            this.signInAsync();
          } else {
            displayAlertifyError({ error: responseJson.message });
          }
        } catch (error) {
          displayAlertifyError({ error: responseJson.message });
        }
      })
      .catch((error) => {
        displayAlertifyError({
          error: "There is a problem in your network connection",
        });
      });
  };

  signInAsync = () => {
    const status = localStorage.getItem("status");
    const route = localStorage.getItem("route");
    if (status !== "" && status !== undefined && status !== null) {
      if (status === "admin") {
        try {
          this.props.history.push("/superadmin-dashboard");
        } catch (error) {
          displayAlertifyError({ error: error });
        }
      } else if (status === "premium") {
        try {
          if (route !== "" && route !== undefined && route !== null) {
            this.props.history.push(route);
          } else {
            this.props.history.push("/admin-dashboard");
          }
        } catch (error) {
          displayAlertifyError({ error: error });
        }
      } else {
        try {
          if (route !== "" && route !== undefined && route !== null) {
            this.props.history.push(route);
          } else {
            this.props.history.push("/payment");
          }
        } catch (error) {
          displayAlertifyError({ error: error });
        }
      }
    }
  };

  globalErrorHandler = (error) => {
    const { response } = error;
    let message;
    if (response) {
      message = response.data.message;
    } else {
      message = error.toString();
    }
  };

  render() {
    return (
      <div className="content">
        <div className="container-fluid container-login">
          <div
            className="row justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <div className="col-12 col-md-9 col-xl-5">
              <div className="card">
                <div className="card-header card-header-primary">
                  <h4 className="card-title text-center font-weight-bold text-uppercase">
                    <b>Login</b>
                  </h4>
                </div>
                <div className="card-body">
                  <div className="logo text-center my-3">
                    <img
                      src={process.env.PUBLIC_URL + "/logo.png"}
                      alt="Logo"
                      className="logo"
                    />
                  </div>
                  <form>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <label className="bmd-label-floating">
                            Email address
                          </label>
                          <input
                            type="text"
                            className="form-control input-box"
                            id="uname"
                            name="email"
                            onChange={this.onChange}
                            value={this.state.email}
                            required="required"
                            autoFocus
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <label className="bmd-label-floating">Password</label>
                          <input
                            type="password"
                            className="form-control input-box"
                            id="pwd"
                            name="password"
                            onChange={this.onChange}
                            onKeyDown={this.handleKeyDown}
                            value={this.state.password}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="text-center mt-3">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={() => this.Login()}
                      >
                        Log In
                      </button>
                    </div>
                    <div className="row py-2 justify-content-center">
                      <h4 className="font-weight-bold">-- Or --</h4>
                    </div>
                    <div className="">
                      <Link to="/signup" className="btn btn-primary w-100">
                        <Box fontWeight="fontWeightRegular">Sign Up?</Box>
                      </Link>
                    </div>
                    <div className="text-right pt-3">
                      <Link to="/forgotPassword" className="link-colour">
                        <Box fontWeight="fontWeightBold">Forget Password?</Box>
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
